import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles';

const useStyles = createUseStyles(
  {
    paragraph: {
      fontSize: '16px',
      lineHeight: '24px',
      color: 'var(--x-text-color-2)',
      maxWidth: '265px',
      fontWeight: FontWeight.Medium,
      textAlign: 'center',
    },
  },
  { name: 'hero-file-uploader' },
);

export default useStyles;
